export enum EntregaNoCdTypes {
  'LOAD_REQUEST' = '@entregaNoCd/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@entregaNoCd/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@entregaNoCd/LOAD_FAILURE',

  'FILTER_ENTREGACD' = '@entregaNoCd/FILTER_ENTREGACD',
  'SORTER_ENTREGACD' = '@entregaNoCd/SORTER_ENTREGACD',
  'CLEAN_ENTREGACD' = '@entregaNoCd/CLEAN_ENTREGACD',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface IEntregaNoCd {
  cpfMotorista: string;
  nomeMotorista: string;
  ordemCarga: number;
  peso: number;
  placa: string;
  tipoVeiculo: string;
  valor: number;
  status: string;
  nomeTransportadora: string;
  codEmp: number;
  nomeDestinatario: string;
  clienteRetira: boolean;
  assoalho: string;
}

export interface IFilterEntregaNoCd {
  codTipoVeiculo: number;
  status: string;
  placa: string;
  ordemCarga: number;
  codDestinatario: number;
  codTransportadora: number;
}

export interface IFilter {
  filter: IFilterEntregaNoCd | undefined;
}

export interface EntregaNoCdState {
  readonly data: IEntregaNoCd[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly filter?: IFilter;
  readonly pagination: Pagination;
  readonly sorter?: any;
}
